import SolicitacaoPagamentoPj from './componentes/SolicitacaoPagamentoPj.vue';
import SolicitacaoPagamentoPjLista from './componentes/SolicitacaoPagamentoPjLista.vue';
import SolicitacaoPagamentoPjForm from './componentes/SolicitacaoPagamentoPjForm.vue';
import SolicitacaoPagamentoRelatorio from './componentes/SolicitacaoPagamentoRelatorio.vue';

export default {
  path: '/solicitacao-pagamento-rateio-pj',
  component: SolicitacaoPagamentoPj,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoPagamentoPjLista,
      name: 'solicitacao-pagamento-rateio-pj',
    },
    {
      path: 'nova',
      component: SolicitacaoPagamentoPjForm,
      name: 'solicitacao-pagamento-rateio-pj.nova',
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoPagamentoRelatorio,
      name: 'solicitacao-pagamento-rateio-pj.relatorio'
    },
    {
      path: ':idCript',
      component: SolicitacaoPagamentoPjForm,
      name: 'solicitacao-pagamento-rateio-pj.editar'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-pagamento-rateio/juridica/rotas.js